var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgc-nav"},[_c('nav',{staticClass:"bgc-nav-bar"},[_c('div',{staticClass:"bgc-nav-main"},[_vm._v("\n      游戏导航栏\n    ")])])])}]

export { render, staticRenderFns }